import { startScraping } from "@/lib/scraping";
import type { AddressProviderTreeNode, LogChunk } from "@shared/types";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogsScroll } from "./useLogsScroll";

const useScraping = () => {
  const navigate = useNavigate();
  const [scraping, setScraping] = useState(false);
  const [rawLogs, setRawLogs] = useState<LogChunk[]>([]);
  const [initialAddresses, setInitialAddresses] = useState<AddressProviderTreeNode[]>([]);

  const logsEndRef = useLogsScroll(rawLogs);
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const handleStartScraping = () =>
    startScraping({
      setScraping,
      setRawLogs,
      setInitialAddresses,
      mountedRef,
    });

  const handleClearLogs = () => setRawLogs([]);

  return {
    scraping,
    rawLogs,
    initialAddresses,
    logsEndRef,
    handleStartScraping,
    handleClearLogs,
    navigate,
  };
};

export { useScraping };
